function Ireland({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_1395)">
      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
      <path d="M32 16C32 9.12061 27.658 3.25586 21.5652 0.995239V31.0049C27.658 28.7441 32 22.8795 32 16Z" fill="#FF9811"/>
      <path d="M0 16C0 22.8795 4.342 28.7441 10.4348 31.0049V0.995239C4.342 3.25586 0 9.12061 0 16Z" fill="#6DA544"/>
    </g>
  </svg>

  `;

  return baseXml;
}

export default Ireland;
